// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/" + chunkId + "." + {"183": "c5c5e2dc","938": "14e2ab47",}[chunkId] + ".css"
}